import { Box, TextField } from "@mui/material";
import React from "react";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";

const setMeshSizePattern = function (validationData) {
  if (
    validationData &&
    validationData.hasOwnProperty("MESH_MINIMUM") &&
    validationData.hasOwnProperty("MESH_MAXIMUM")
  ) {
    return validationData.MESH_MINIMUM + " - " + validationData.MESH_MAXIMUM;
  }
  return "no valid pattern";
};

export default function MeshSize(props) {
  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Mesh / Ring Size</h2>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              label="Mesh / Ring size:"
              className="number-of-input"
              inputProps={{ min: 0, style: { textAlign: "center" } }}
              value={props.mesh_size ? Number(props.mesh_size) : ""}
              name="mesh_size"
              type="number"
              onChange={(e) => props.handleInputChange(e)}
              helperText={setMeshSizePattern(props.validation)}
            />
          </FormControl>
          <HelpText helpText={getHelpText(props.helpText, "mesh_size")} />
        </Grid>
      </Grid>
    </Box>
  );
}
